module.exports = __webpack_public_path__ + "img/background.64c2b671.png";